var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15756",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15756",
    transform: "translate(-258 -582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15754",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15753",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15753",
    transform: "translate(-78 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10550",
    "data-name": "\\u9577\\u65B9\\u5F62 10550",
    width: 32,
    height: 32,
    transform: "translate(336 581)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Sign_Out",
    "data-name": "Sign Out",
    transform: "translate(260.018 583.809)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10547",
    "data-name": "\\u9577\\u65B9\\u5F62 10547",
    width: 28.774,
    height: 28.774,
    transform: "translate(-0.019 0.191)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21764",
    "data-name": "\\u30D1\\u30B9 21764",
    d: "M174.011,96.743a1,1,0,0,1-.707-1.707l4.164-4.165L173.3,86.707a1,1,0,1,1,1.414-1.414l4.87,4.872a1,1,0,0,1,0,1.414l-4.87,4.872A1,1,0,0,1,174.011,96.743Z",
    transform: "translate(-153.819 -76.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_680",
    "data-name": "\\u7DDA 680",
    d: "M12.988,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H12.988a1,1,0,0,1,1,1A1,1,0,0,1,12.988,1Z",
    transform: "translate(12.071 14.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21765",
    "data-name": "\\u30D1\\u30B9 21765",
    d: "M47.424,61.415h-6.5A1.93,1.93,0,0,1,39,59.487V40.928A1.93,1.93,0,0,1,40.928,39h6.5a1,1,0,0,1,0,2H41V59.415h6.424a1,1,0,0,1,0,2Z",
    transform: "translate(-35.352 -35.872)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingLogout);
export default __webpack_public_path__ + "static/media/settingLogout.a06acaf14df638a425ab078d5d5fabb0.svg";
export { ForwardRef as ReactComponent };